// extracted by mini-css-extract-plugin
export default {"LoginPageHolder":"Auth_LoginPageHolder__kGVYQ","ImageHolder":"Auth_ImageHolder__BSuJc","ChangeAuth":"Auth_ChangeAuth__fp2e7","resend":"Auth_resend__s4Z4e"};